"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const base_1 = __importDefault(require("./base"));
const defaults_1 = require("./defaults");
const image_object_1 = __importDefault(require("./image-object"));
class Statistic extends base_1.default {
    constructor(data = {
        description: undefined,
        icon: undefined,
        value: undefined,
    }) {
        super(data);
        this.description = (0, defaults_1.defaultString)(data.description);
        this.icon = new image_object_1.default((0, defaults_1.defaultObject)(data.icon));
        this.value = (0, defaults_1.defaultString)(data.value);
        this.value_type = (0, defaults_1.defaultString)(data.value_type);
    }
    get convertedValue() {
        if (!this.value) {
            return this.value_type === 'time' ? '0:00' : '0';
        }
        return this.value_type === 'time' ? (0, moment_1.default)(this.value, ['hh:mm:ss']).format('HH:mm') : this.value;
    }
}
exports.default = Statistic;
